import { Routes, RouterModule } from '@angular/router';

import { MainComponent } from "./main/main.component";
import { LoginComponent } from "./login/login.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { RedemptionComponent } from "./redemption/redemption.component";
import { IssuanceComponent } from "./issuance/issuance.component";
import { PenjatahanIssuanceComponent } from "./penjatahan/issuance/penjatahanissuance.component";
import { AuctionComponent } from "./auction/auction.component";
import { RedemptionConfirmComponent } from "./redemption-confirm/redemption-confirm.component";
import { UserComponent } from "./user/user.component";
import { GroupComponent } from "./group/group.component";
import { AgentComponent } from "./agent/agent.component";
import { InvestorComponent } from "./investor/investor.component";
import { UploadIssuanceComponent } from 'app/upload-issuance/upload-issuance.component';
import { UploadCheckerComponent } from 'app/upload-checker/upload-checker.component';
import { DashboardOnlineComponent } from 'app/dashboard-online/dashboard-online.component';
import { CustomRedemptionComponent } from './ritel-online/custom-redemption/custom-redemption.component';
import { CustomPemesananComponent } from './ritel-online/custom-pemesanan/custom-pemesanan.component';
import { RitelOnlineComponent } from './ritel-online/ritel-online.component';
import { DownloadComponent } from './download/download.component';
import { DownloadDailyReportComponent } from './downloaddailyreport/downloaddailyreport.component';
import { EmailComponent } from './email/email.component';
import { PushNtpnComponent } from './push-ntpn/push-ntpn.component';

const routes: Routes = [
    { path: 'login', component: LoginComponent },
    {
        path: '', component: MainComponent, children: [
            { path: 'dashboard', component: DashboardComponent },
            { path: 'dashboardonline', component: DashboardOnlineComponent },
            { path: 'userprofile', component: UserProfileComponent },
            { path: 'pemesanan/redemption/:id', component: RedemptionComponent },
            { path: 'pemesanan/issuance/:id', component: IssuanceComponent },
            { path: 'penjatahan/issuance/:id', component: PenjatahanIssuanceComponent },
            { path: 'pemesanan/confirm/redemption', component: RedemptionConfirmComponent },
            { path: 'controlpanel/user', component: UserComponent },
            { path: 'controlpanel/group', component: GroupComponent },
            { path: 'auction/list/:id', component: AuctionComponent },
            { path: 'auction/agent/:id', component: AgentComponent },
            { path: 'auction/investor/:id', component: InvestorComponent },
            { path: 'upload/issuance/:id',component:UploadIssuanceComponent },
            { path: 'uploadchecker/issuance/:id', component: UploadCheckerComponent},
            // { path: 'ritel-online/custom-pemesanan', component: CustomPemesananComponent},
            { path: 'ritelonline/monitoring/redemption/:id', component: CustomRedemptionComponent},
            { path: 'ritelonline/monitoring/pemesanan/:id', component: CustomPemesananComponent},
            { path: 'download/:id', component: DownloadComponent},
            { path: 'dailyreport/:id', component: DownloadDailyReportComponent},
            { path: 'email/:id', component: EmailComponent},
            { path: 'pushNtpn/:id', component: PushNtpnComponent}
        ]
    },
    {
        path: '**', redirectTo: 'login', pathMatch: 'full'
    },

];
export const appRoutingProviders: any[] = [

];

export const appRoutes: any = RouterModule.forRoot(routes, { useHash: true });


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/app.routes.ts